module.exports = __webpack_public_path__ + "static/media/sf_3100.c356a2b15945d377a67c566a8e48853e.png";